// Generated by CoffeeScript 1.12.7
define('etc/definitions',['require'],function(require) {

  /**
  	A dictionary of predefined definitions.
  
  	@module definitions
   */
  var definitions;
  return definitions = {
    logo: {
      dark: "https://public.surveyplanet.com/logos/surveyplanet-logo.svg",
      light: "https://public.surveyplanet.com/logos/surveyplanet-logo-light.svg",
      black: "https://public.surveyplanet.com/logos/surveyplanet-logo-black.svg",
      white: "https://public.surveyplanet.com/logos/surveyplanet-logo-white.svg"
    },
    audienceStatus: {
      complete: 10,
      disqualify: 20,
      duplicate: 30,
      overquota: 40
    },
    questionTypes: [
      {
        display: "Multiple Choice",
        type: "multiple_choice",
        pro: false
      }, {
        display: "Essay",
        type: "essay",
        pro: false
      }, {
        display: "Rating",
        type: "rating",
        pro: false
      }, {
        display: "Scale",
        type: "scale",
        pro: false
      }, {
        display: "True / False",
        type: "true_false",
        pro: false
      }, {
        display: "Form",
        type: "form",
        pro: false
      }, {
        display: "Scoring",
        type: "scoring",
        pro: false
      }, {
        display: "Range",
        type: "range",
        pro: false
      }, {
        display: "Date / Time",
        type: "date_time",
        pro: false
      }, {
        display: "Image Choice",
        type: "image",
        pro: true
      }
    ]
  };
});

